import React from 'react';
import { Button, ButtonProps } from '@atoms/Button/Button';
import {
  CallToActionCardProps,
  CallToActionCard,
} from '@molecules/CallToAction/CallToActionCard';
import { FormTitle } from '@molecules/FormTitle/FormTitle';
import {
  NavigationLink,
  NavigationLinkObject,
} from '@molecules/NavigationLink/NavigationLink';

interface BeforeYouStartTemplateProps {
  contentTitle: string;
  contentSubtext?: string | React.ReactNode;
  loginButton?: ButtonProps;
  callToActionCards: CallToActionCardProps[];
  linkObjectArrays: NavigationLinkObject[];
}

export const BeforeYouStartTemplate: React.FC<BeforeYouStartTemplateProps> = ({
  contentTitle,
  contentSubtext,
  loginButton,
  callToActionCards,
  linkObjectArrays,
}) => {
  return (
    <form className="text-text-body flex w-[90vw] flex-col">
      <section className="flex flex-col gap-y-3 pt-3 min-[400px]:px-6">
        <NavigationLink linkObjectArrays={linkObjectArrays} />
        <hr className="border-brand-primary w-full border-[1px] border-opacity-25" />
      </section>
      <section
        data-testid="before-you-start-content"
        className="mb-4 flex flex-col min-[400px]:px-6"
      >
        <FormTitle
          text={contentTitle}
          subtext={contentSubtext}
          titleSize="extraLarge"
        />
      </section>
      {loginButton ? (
        <section
          className="my-5 flex items-center justify-between"
          data-testid="signup-or-login"
        >
          <Button
            data-testid="login-button"
            variant="navigation"
            label={loginButton.label}
            onClick={loginButton.onClick}
            size="extraLarge"
            {...loginButton}
          />
        </section>
      ) : null}
      <section
        className="my-5 flex w-full flex-col items-start space-y-4 min-[400px]:mx-6"
        data-testid="navigate-to-form"
      >
        {callToActionCards.map((card) => {
          return <CallToActionCard {...card} key={card.linkText} />;
        })}
      </section>
    </form>
  );
};
